import React,{useState} from 'react'
import './cart.css'
import useAuth from '../../hooks/useAuth'

const Cart = () => {
  const{count,setCount}=useAuth()
const[counter,setCounter]=useState(0)

function inceriment(id){
    let items=count.map((item)=>{
      if(item.id===id){
        return {
          ...item,
          quantity : item.quantity+1
        }
      }
      return item;
    })
     setCount([...items])
    }
  
    function deceriment(id){
      let items=count.map((item)=>{
        if(item.id===id){
          return {
            ...item,
            quantity : item.quantity-1>0 ? item.quantity-1:1
          }
        }
        return item;
      })
       setCount([...items])
      }
    let grandtotal = () => {
      let total=0;
      for(let counts of count){
        total += counts.price * counts.quantity
      }
      return total
    }

    function removeitem(id){
    let item=count.filter((item)=>{
      return item.id !== id
    })
    setCount(item)
    }
  

  return (
    <>
    <section className='cart-head'>
      <div class="container ">
        <h2 class="d-flex justify-content-center mt-4 text-danger">
          My shopping cart
        </h2>
        <h5 className="text-muted">You cart  {count.length} items</h5>
        
        <div class="cart ">
          <div class="col-sm-10 col-md-12  col-lg-10 mx-auto ">
            
            {count.map((item)=>{
              return ( <div key={item.id} class="cart-item ps-3">
              <div class="row">
                <div class="col-md-7 center-item">
                  <img src={item.img} alt="" />
                  <h5>{item.name}</h5>
                  <p className='text-muted'>{item.price}$</p>
                </div>

                <div class="col-md-5 center-item">
                  <div class="input-group number-spinner">
                    <button id="phone-minus" class="btns btn-default"  onClick={()=>{deceriment(item.id)}}>
                      <i class="fas fa-minus"></i>
                    </button>
                    <input
                      id="phone-number"
                      type="number"
                      min="0"
                      class="form-control text-center"
                      value={item.quantity}
                    />
                    <button id="phone-plus" class="btns btn-default" onClick={()=>{inceriment(item.id)}} >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                  <h5><span id="phone-total" >{item.quantity*item.price}$</span></h5>
                  <button id="remove-item" class="remove-item" onClick={()=>{removeitem(item.id)}}>
                  <i class="fa-regular fa-trash-can"></i>
                    </button>
                 
                </div>
              </div>
            </div>
              )
            })}
           
           </div>

          
        </div>
        <div class="cart-item">
              <div class="row">
                <div class="col-8">
                  <h5>Subtotal:</h5>
                  <h5>Tax:</h5>
                  <h5>Total:</h5>
                </div>

                <div class="col-4 status">
                  <h5>$<span id="sub-total">00</span></h5>
                  <h5>$<span id="tax-amount">0</span></h5>
                  <h5>$<span id="total-price">{grandtotal()}</span></h5>
                </div>
              </div>
           
            <div class="col-md-12 pt-4 pb-4 mb-4">
              <button type="button" class="btn btn-success check-out">
                Check Out
              </button>
            </div>
            </div>
      </div>
    </section>

   
    </>
  )
}

export default Cart